import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getCompanyLogo = (token: string, backend: string) => {
    return fetch(`${getApiUrl(backend)}get_company_logo`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    }) 
}

export default getCompanyLogo